import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export interface PiperVoice {
  id: string; language: string; languageLabel: string; name: string; gender: string;
  quality: string; sampleRate: number; license: string; modelCard: string;
  installed: boolean; modelBytes?: number;
}
export interface PiperRequest {
  voiceId: string; text: string; runs: number; lengthScale: number; noiseScale: number; noiseWScale: number;
}
export interface PiperResult {
  voice: PiperVoice; text: string; contentType: string; audioBase64: string;
  metrics: { runs:number; coldStart:boolean; modelLoadMs:number; synthesisMs:number; minSynthesisMs:number;
    maxSynthesisMs:number; audioDurationMs:number; realTimeFactor:number; sampleRate:number; audioBytes:number;
    processMemoryBeforeMiB:number; processMemoryAfterMiB:number };
  settings: Record<string, unknown>; warning: string;
}

@Injectable({providedIn: 'root'})
export class PiperTtsApi {
  private readonly base = environment.apiHost + '/api/v1/rnd/piper-tts';
  private readonly options = {headers:new HttpHeaders({'X-Skip-Spinner':'true'})};
  constructor(private http:HttpClient) {}
  status() { return this.http.get<any>(this.base + '/status', this.options); }
  voices() { return this.http.get<PiperVoice[]>(this.base + '/voices', this.options); }
  synthesize(request:PiperRequest) { return this.http.post<PiperResult>(this.base + '/synthesize', request, this.options); }
}
